import { z } from "zod";
/**
 * Factory function to create UpdateTourStatusValidator with translations
 */
export const createUpdateTourStatusValidator = (t) => z.object({
    tourStartedAt: z.string().datetime().optional().nullable(),
    tourCompletedAt: z.string().datetime().optional().nullable(),
    tourStepIndex: z.number().int().min(0, t("validation.tour.stepIndexMin")).optional().nullable(),
});
